export default __webpack_public_path__ + "static/media/ILPlatform_Programme12-16.0a90d5b0.webp";